import { render, staticRenderFns } from "./SchoolDetail/template.html?vue&type=template&id=4964e78b&scoped=true&"
import script from "./SchoolDetail/script.ts?vue&type=script&lang=js&"
export * from "./SchoolDetail/script.ts?vue&type=script&lang=js&"
import style0 from "./SchoolDetail/style.scss?vue&type=style&index=0&id=4964e78b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4964e78b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VDataTable,VDivider,VImg})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
